var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.055 3.4l-0.657-0.329-0.533 0.266v0.001l-5.864 2.932-6.398-3.199-6.931 3.465v22.391l6.931-3.465 6.398 3.199 6.398-3.199 6.931 3.465v-22.391l-6.274-3.137zM9.069 24.537l-5.331 2.666v-20.007l5.331-2.666v20.007zM15.467 27.203l-5.331-2.666v-20.007l5.331 2.666v20.007zM21.864 24.537l-5.331 2.666v-20.007l5.331-2.666v20.007zM28.262 27.203l-5.331-2.666v-20.007l5.331 2.666v20.007z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d96f52fd7dc26e4f080bc584dac5962a.svg";
export { ForwardRef as ReactComponent };